// HoverIntent r6 // 2011.02.26 // jQuery 1.5.1+ <http://cherne.net/brian/resources/jquery.hoverIntent.html> || @param  f  onMouseOver function || An object with configuration options || @param  g  onMouseOut function  || Nothing (use configuration options object) || @author Brian Cherne brian(at)cherne(dot)net
(function($){$.fn.hoverIntent=function(f,g){var cfg={sensitivity:7,interval:100,timeout:0};cfg=$.extend(cfg,g?{over:f,out:g}:f);var cX,cY,pX,pY;var track=function(ev){cX=ev.pageX;cY=ev.pageY};var compare=function(ev,ob){ob.hoverIntent_t=clearTimeout(ob.hoverIntent_t);if((Math.abs(pX-cX)+Math.abs(pY-cY))<cfg.sensitivity){$(ob).unbind("mousemove",track);ob.hoverIntent_s=1;return cfg.over.apply(ob,[ev])}else{pX=cX;pY=cY;ob.hoverIntent_t=setTimeout(function(){compare(ev,ob)},cfg.interval)}};var delay=function(ev,ob){ob.hoverIntent_t=clearTimeout(ob.hoverIntent_t);ob.hoverIntent_s=0;return cfg.out.apply(ob,[ev])};var handleHover=function(e){var ev=jQuery.extend({},e);var ob=this;if(ob.hoverIntent_t){ob.hoverIntent_t=clearTimeout(ob.hoverIntent_t)}if(e.type=="mouseenter"){pX=ev.pageX;pY=ev.pageY;$(ob).on("mousemove",track);if(ob.hoverIntent_s!=1){ob.hoverIntent_t=setTimeout(function(){compare(ev,ob)},cfg.interval)}}else{$(ob).unbind("mousemove",track);if(ob.hoverIntent_s==1){ob.hoverIntent_t=setTimeout(function(){delay(ev,ob)},cfg.timeout)}}};return this.on('mouseenter',handleHover).on('mouseleave',handleHover)}})(jQuery);

// ScrollTo // Copyright (c) 2007-2015 Ariel Flesler - aflesler@gmail.com | http://flesler.blogspot.com | Licensed under MIT | @author Ariel Flesler | @version 2.1.0
;(function(l){'use strict';l(['jquery'],function($){var k=$.scrollTo=function(a,b,c){return $(window).scrollTo(a,b,c)};k.defaults={axis:'xy',duration:0,limit:true};function isWin(a){return!a.nodeName||$.inArray(a.nodeName.toLowerCase(),['iframe','#document','html','body'])!==-1}$.fn.scrollTo=function(f,g,h){if(typeof g==='object'){h=g;g=0}if(typeof h==='function'){h={onAfter:h}}if(f==='max'){f=9e9}h=$.extend({},k.defaults,h);g=g||h.duration;var j=h.queue&&h.axis.length>1;if(j){g/=2}h.offset=both(h.offset);h.over=both(h.over);return this.each(function(){if(f===null)return;var d=isWin(this),elem=d?this.contentWindow||window:this,$elem=$(elem),targ=f,attr={},toff;switch(typeof targ){case'number':case'string':if(/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(targ)){targ=both(targ);break}targ=d?$(targ):$(targ,elem);if(!targ.length)return;case'object':if(targ.is||targ.style){toff=(targ=$(targ)).offset()}}var e=$.isFunction(h.offset)&&h.offset(elem,targ)||h.offset;$.each(h.axis.split(''),function(i,a){var b=a==='x'?'Left':'Top',pos=b.toLowerCase(),key='scroll'+b,prev=$elem[key](),max=k.max(elem,a);if(toff){attr[key]=toff[pos]+(d?0:prev-$elem.offset()[pos]);if(h.margin){attr[key]-=parseInt(targ.css('margin'+b),10)||0;attr[key]-=parseInt(targ.css('border'+b+'Width'),10)||0}attr[key]+=e[pos]||0;if(h.over[pos]){attr[key]+=targ[a==='x'?'width':'height']()*h.over[pos]}}else{var c=targ[pos];attr[key]=c.slice&&c.slice(-1)==='%'?parseFloat(c)/100*max:c}if(h.limit&&/^\d+$/.test(attr[key])){attr[key]=attr[key]<=0?0:Math.min(attr[key],max)}if(!i&&h.axis.length>1){if(prev===attr[key]){attr={}}else if(j){animate(h.onAfterFirst);attr={}}}});animate(h.onAfter);function animate(a){var b=$.extend({},h,{queue:true,duration:g,complete:a&&function(){a.call(elem,targ,h)}});$elem.animate(attr,b)}})};k.max=function(a,b){var c=b==='x'?'Width':'Height',scroll='scroll'+c;if(!isWin(a))return a[scroll]-$(a)[c.toLowerCase()]();var d='client'+c,doc=a.ownerDocument||a.document,html=doc.documentElement,body=doc.body;return Math.max(html[scroll],body[scroll])-Math.min(html[d],body[d])};function both(a){return $.isFunction(a)||$.isPlainObject(a)?a:{top:a,left:a}}$.Tween.propHooks.scrollLeft=$.Tween.propHooks.scrollTop={get:function(t){return $(t.elem)[t.prop]()},set:function(t){var a=this.get(t);if(t.options.interrupt&&t._last&&t._last!==a){return $(t.elem).stop()}var b=Math.round(t.now);if(a!==b){$(t.elem)[t.prop](b);t._last=this.get(t)}}};return k})}(typeof define==='function'&&define.amd?define:function(a,b){'use strict';if(typeof module!=='undefined'&&module.exports){module.exports=b(require('jquery'))}else{b(jQuery)}}));

// isMobile
!function(a){var b=/iPhone/i,c=/iPod/i,d=/iPad/i,e=/(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,f=/Android/i,g=/(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,h=/(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,i=/IEMobile/i,j=/(?=.*\bWindows\b)(?=.*\bARM\b)/i,k=/BlackBerry/i,l=/BB10/i,m=/Opera Mini/i,n=/(CriOS|Chrome)(?=.*\bMobile\b)/i,o=/(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,p=new RegExp("(?:Nexus 7|BNTV250|Kindle Fire|Silk|GT-P1000)","i"),q=function(a,b){return a.test(b)},r=function(a){var r=a||navigator.userAgent,s=r.split("[FBAN");return"undefined"!=typeof s[1]&&(r=s[0]),s=r.split("Twitter"),"undefined"!=typeof s[1]&&(r=s[0]),this.apple={phone:q(b,r),ipod:q(c,r),tablet:!q(b,r)&&q(d,r),device:q(b,r)||q(c,r)||q(d,r)},this.amazon={phone:q(g,r),tablet:!q(g,r)&&q(h,r),device:q(g,r)||q(h,r)},this.android={phone:q(g,r)||q(e,r),tablet:!q(g,r)&&!q(e,r)&&(q(h,r)||q(f,r)),device:q(g,r)||q(h,r)||q(e,r)||q(f,r)},this.windows={phone:q(i,r),tablet:q(j,r),device:q(i,r)||q(j,r)},this.other={blackberry:q(k,r),blackberry10:q(l,r),opera:q(m,r),firefox:q(o,r),chrome:q(n,r),device:q(k,r)||q(l,r)||q(m,r)||q(o,r)||q(n,r)},this.seven_inch=q(p,r),this.any=this.apple.device||this.android.device||this.windows.device||this.other.device||this.seven_inch,this.phone=this.apple.phone||this.android.phone||this.windows.phone,this.tablet=this.apple.tablet||this.android.tablet||this.windows.tablet,"undefined"==typeof window?this:void 0},s=function(){var a=new r;return a.Class=r,a};"undefined"!=typeof module&&module.exports&&"undefined"==typeof window?module.exports=r:"undefined"!=typeof module&&module.exports&&"undefined"!=typeof window?module.exports=s():"function"==typeof define&&define.amd?define("isMobile",[],a.isMobile=s()):a.isMobile=s()}(this);

// Makes it safe to do console.log() always.
(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try{console.log();return window.console;}catch(err){return window.console={};}})());

///JavaScript Cookie v2.0.3 // https://github.com/js-cookie/js-cookie // Copyright 2006, 2015 Klaus Hartl & Fagner Brack // Released under the MIT license
!function(e){if("function"==typeof define&&define.amd)define(e);else if("object"==typeof exports)module.exports=e();else{var n=window.Cookies,o=window.Cookies=e();o.noConflict=function(){return window.Cookies=n,o}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var o=arguments[e];for(var t in o)n[t]=o[t]}return n}return function n(o){function t(n,i,r){var c;if(arguments.length>1){if("number"==typeof(r=e({path:"/"},t.defaults,r)).expires){var s=new Date;s.setMilliseconds(s.getMilliseconds()+864e5*r.expires),r.expires=s}try{c=JSON.stringify(i),/^[\{\[]/.test(c)&&(i=c)}catch(e){}return i=(i=encodeURIComponent(String(i))).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=(n=(n=encodeURIComponent(String(n))).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent)).replace(/[\(\)]/g,escape),document.cookie=[n,"=",i,r.expires&&"; expires="+r.expires.toUTCString(),r.path&&"; path="+r.path,r.domain&&"; domain="+r.domain,r.secure?"; secure":""].join("")}n||(c={});for(var a=document.cookie?document.cookie.split("; "):[],p=/(%[0-9A-Z]{2})+/g,d=0;d<a.length;d++){var f=a[d].split("="),l=f[0].replace(p,decodeURIComponent),u=f.slice(1).join("=");'"'===u.charAt(0)&&(u=u.slice(1,-1));try{if(u=o&&o(u,l)||u.replace(p,decodeURIComponent),this.json)try{u=JSON.parse(u)}catch(e){}if(n===l){c=u;break}n||(c[l]=u)}catch(e){}}return c}return t.get=t.set=t,t.getJSON=function(){return t.apply({json:!0},[].slice.call(arguments))},t.defaults={},t.remove=function(n,o){t(n,"",e(o,{expires:-1}))},t.withConverter=n,t}()});

// jquery-match-height master by @liabru, http://brm.io/jquery-match-height/, License: MIT
!function(a){"use strict";"function"==typeof define&&define.amd?define(["jquery"],a):"undefined"!=typeof module&&module.exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){var b=-1,c=-1,d=function(a){return parseFloat(a)||0},e=function(b){var c=1,e=a(b),f=null,g=[];return e.each(function(){var b=a(this),e=b.offset().top-d(b.css("margin-top")),h=g.length>0?g[g.length-1]:null;null===h?g.push(b):Math.floor(Math.abs(f-e))<=c?g[g.length-1]=h.add(b):g.push(b),f=e}),g},f=function(b){var c={byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof b?a.extend(c,b):("boolean"==typeof b?c.byRow=b:"remove"===b&&(c.remove=!0),c)},g=a.fn.matchHeight=function(b){var c=f(b);if(c.remove){var d=this;return this.css(c.property,""),a.each(g._groups,function(a,b){b.elements=b.elements.not(d)}),this}return this.length<=1&&!c.target?this:(g._groups.push({elements:this,options:c}),g._apply(this,c),this)};g.version="master",g._groups=[],g._throttle=80,g._maintainScroll=!1,g._beforeUpdate=null,g._afterUpdate=null,g._rows=e,g._parse=d,g._parseOptions=f,g._apply=function(b,c){var h=f(c),i=a(b),j=[i],k=a(window).scrollTop(),l=a("html").outerHeight(!0),m=i.parents().filter(":hidden");return m.each(function(){var b=a(this);b.data("style-cache",b.attr("style"))}),m.css("display","block"),h.byRow&&!h.target&&(i.each(function(){var b=a(this),c=b.css("display");"inline-block"!==c&&"flex"!==c&&"inline-flex"!==c&&(c="block"),b.data("style-cache",b.attr("style")),b.css({display:c,"padding-top":"0","padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),j=e(i),i.each(function(){var b=a(this);b.attr("style",b.data("style-cache")||"")})),a.each(j,function(b,c){var e=a(c),f=0;if(h.target)f=h.target.outerHeight(!1);else{if(h.byRow&&e.length<=1)return void e.css(h.property,"");e.each(function(){var b=a(this),c=b.attr("style"),d=b.css("display");"inline-block"!==d&&"flex"!==d&&"inline-flex"!==d&&(d="block");var e={display:d};e[h.property]="",b.css(e),b.outerHeight(!1)>f&&(f=b.outerHeight(!1)),c?b.attr("style",c):b.css("display","")})}e.each(function(){var b=a(this),c=0;h.target&&b.is(h.target)||("border-box"!==b.css("box-sizing")&&(c+=d(b.css("border-top-width"))+d(b.css("border-bottom-width")),c+=d(b.css("padding-top"))+d(b.css("padding-bottom"))),b.css(h.property,f-c+"px"))})}),m.each(function(){var b=a(this);b.attr("style",b.data("style-cache")||null)}),g._maintainScroll&&a(window).scrollTop(k/l*a("html").outerHeight(!0)),this},g._applyDataApi=function(){var b={};a("[data-match-height], [data-mh]").each(function(){var c=a(this),d=c.attr("data-mh")||c.attr("data-match-height");d in b?b[d]=b[d].add(c):b[d]=c}),a.each(b,function(){this.matchHeight(!0)})};var h=function(b){g._beforeUpdate&&g._beforeUpdate(b,g._groups),a.each(g._groups,function(){g._apply(this.elements,this.options)}),g._afterUpdate&&g._afterUpdate(b,g._groups)};g._update=function(d,e){if(e&&"resize"===e.type){var f=a(window).width();if(f===b)return;b=f}d?c===-1&&(c=setTimeout(function(){h(e),c=-1},g._throttle)):h(e)},a(g._applyDataApi),a(window).on("load",function(a){g._update(!1,a)}),a(window).on("resize orientationchange",function(a){g._update(!0,a)})});

jQuery.fn.sortDomElements = (function() {
    return function(comparator) {
        return Array.prototype.sort.call(this, comparator).each(function(i) {
              this.parentNode.appendChild(this);
        });
    };
})();

jQuery(function($) {
  	if(!isMobile.any) {
      $('body').addClass('isNotMobile');
    }

  	$(document).on("click", ".quantity-box .minus", function() {
      	var wrapper = $(this).parent();
    	try {
          wrapper.find('input[type=number]').get(0).stepDown();
          wrapper.find('input[type=number]').change();
        } catch(e) {
          var value = (parseInt(wrapper.find('input[type=number]').val())-1);
          wrapper.find('input[type=number]').val((value>=0 ? value : 0));
          wrapper.find('input[type=number]').change();
        }
  	});
  	$(document).on("click", ".quantity-box .plus", function() {
      	var wrapper = $(this).parent();
    	try {
          wrapper.find('input[type=number]').get(0).stepUp();
          wrapper.find('input[type=number]').change();
        } catch(e) {
          var value = (parseInt(wrapper.find('input[type=number]').val())+1);
          wrapper.find('input[type=number]').val(value);
          wrapper.find('input[type=number]').change();
        }
  	});

  	/********* QUICK VIEW *********/
  	$(document).on('click', '.product-item .quick-view-btn', function(){
      var url = $(this).data('url');
      $('#loading-overlay').show();

      $.ajax({
        url: url,
        cache: false
      }).done(function(data){
        $('#loading-overlay').hide();
        Simplistic.openModal(data, 'quick-view');
      });

      return false;
    });

  	if($('#side-cart').length > 0) {
    	initSideCart();
  	}

  	
  		$('body').on('submit', '.add-to-cart-form', function(){
            var form = $(this);
            if(validateAddCart(form)) {
              if (form.find('.chk-add').length >=2)
                addToCart2Products(form);
              else
                addToCart(form);
            }
            return false;
        });
  	

  	$(window).on('scroll', function(){
      if($(this).scrollTop()<=200) {
        $('.scrollup').fadeOut();
      } else {
        $('.scrollup').fadeIn();
      }

      
        var logo = $('#header .logo');
        var isAndroid = /(android)/i.test(navigator.userAgent);
        //var duration = isAndroid ? 0 : 200; //use for jquery 1.x version
        var duration = 200;
        if( $(this).scrollTop()>=80 ) {
          if (!logo.hasClass('drop')) {
            logo.addClass('drop');
            /*
            //jquery version
            logo.find('.logo-header-drop').stop( true, true );
            logo.find('.logo-top').stop( true, true ).fadeOut({
              duration: duration,
              complete: function(){
                logo.find('.logo-header-drop').fadeIn(duration);
              }
            });*/

            //using velocity
            logo.find('.logo-header-drop').velocity("stop");
            logo.find('.logo-top').velocity("stop").velocity({
              opacity: 0},{
              duration: duration,
              complete:function(){
                logo.find('.logo-top').css('display','none');
                logo.find('.logo-header-drop').css('display', 'block').velocity({opacity: 1}, {duration: duration});
              }
            });

          }
        } else {
          if (logo.hasClass('drop')) {
            logo.removeClass('drop');

            /*
            //jquery version
            logo.find('.logo-top').stop( true, true );
            logo.find('.logo-header-drop').stop( true, true ).fadeOut({
              duration: duration,
              complete: function(){
                logo.find('.logo-top').fadeIn(duration);
              }
            });
            */

            //using velocity
            logo.find('.logo-top').velocity("stop");
            logo.find('.logo-header-drop').velocity("stop").velocity({
              opacity: 0},{
              duration: duration,
              complete:function(){
                logo.find('.logo-header-drop').css('display','none');
                logo.find('.logo-top').css('display', 'block').velocity({opacity: 1}, {duration: duration});
              }
            });

          }
        }
      
    });

  	setupDropdownMenus();
});

/**
 * Support for dropdown menus
 */
function setupDropdownMenus(){
  $('.header-drop .main-menu').html($('#header .main-menu').html());
    var config = {
      over: function () {
          $(this).addClass('active').find('.submenu:first').slideDown();
      },
      timeout: 400,
      out: function () {
        $(this).removeClass('active').find('.submenu:first').slideUp();
      }
    };
    $('.main-menu .has-dropdown').hoverIntent(config);
}

function validateAddCart(form) {
  if(form.find('input[name=id]').val()=='') {
        var allOptionsSelected;
      	if(form.find('.single-option-selector').length > 0) {
            allOptionsSelected = true;
            form.find('.single-option-selector').each(function(){
                if($(this).val()=="") {
                    allOptionsSelected = false;
                    return false;
                }
            });
        } else {
          	allOptionsSelected = false;
        }

      	if(allOptionsSelected) {
          	var errorMsg = form.find('.validation-msg').text();
          	if(errorMsg) {
          		alert(errorMsg);
            } else {
            	alert("The selected variant is sold out.");
            }
        } else {
        	var labels = [];
            form.find('.options label').each(function(key, obj){
                labels.push($(obj).text().replace(':', '').trim());
            });
            alert("You must select a "+labels.join('/')+".");
        }
      	return false;
    }
  	return true;
}

function initSideCart() {
	$('.header .cart-wrap').on('click', function(e){
      e.stopPropagation();
      showSideCart(true);
      return false;
    });

    $(document).on('click', function(event){
      if(!$(event.target).closest('#side-cart').length && $(event.target).attr('id')!="loading-overlay" && $('#side-cart').hasClass('open')) {
        hideSideCart();
      }
    });
}

/**
 * Ajax add-to-cart
 */
function addToCart(form){
	$('#loading-overlay').show();
  	if(modal) modal.close();
    console.log("test")
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		data: form.serialize(),
		dataType: 'json',
		error: addToCartFail,
		success: addToCartSuccess,
		cache: false
	});
}

var async_cart_json = jQuery.Deferred();

function setUtmAttributes(form){
  var utmData = Simplistic.utm.get();
  if (utmData) {
    try {
      if (utmData.href.indexOf('?')==-1) {
        utmData.href.replace('utm_source=', '?utm_source=')
      }
      var pairs = utmData.href.split('?')[1].split('&');
      var result = {};
      pairs.forEach(function(pair) {
          pair = pair.split('=');
          result[pair[0]] = decodeURIComponent(pair[1] || '');
      });
      var utmParams = JSON.stringify(result);
      var utmSource = Simplistic.getQueryParam('utm_source', utmData.href);

      form.find('#attributes-source').val(utmSource);
      form.find('#attributes-utm-params').val(utmParams);
    } catch (e) {
      console.error('BAD UTM DATA, current data:\n', utmData, '\nerror:\n', e);
    }
  }
}

function isShopifyVerificationResponse(jqXHR) {
  var body = jqXHR && jqXHR.responseText ? jqXHR.responseText : '';
  return jqXHR.status === 403 &&
    body.indexOf('Your connection needs to be verified') !== -1;
}

function retryCartAdd(dataFn, successFn, errorFn, maxAttempts) {
  var attempt = 0;
  maxAttempts = maxAttempts || 5;

  function run() {
    attempt++;

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: dataFn(),
      dataType: 'json',
      cache: false,
      headers: { 'Accept': 'application/json' },
      success: successFn,
      error: function(jqXHR, textStatus, errorThrown) {
        var retryable =
          isShopifyVerificationResponse(jqXHR) ||
          jqXHR.status === 0 ||
          jqXHR.status === 429 ||
          jqXHR.status >= 500;

        if (retryable && attempt < maxAttempts) {
          setTimeout(run, 1000 * attempt);
          return;
        }

        errorFn(jqXHR, textStatus, errorThrown);
      }
    });
  }

  run();
}


/**
 * Ajax add-to-cart 2 products
 */
function addToCart2Products(form){
  async_cart_json = jQuery.Deferred();
  var validationsPassed = []; //REF CNCT-155
  setUtmAttributes(form); //CC-52

  $.getJSON('/cart.js')
    .fail(addToCartFail)
    .done(function(cart) {
      var clearCartRequest;

      if (cart && cart.item_count > 0) {
        clearCartRequest = $.get('/cart/clear.json');
      } else {
        clearCartRequest = $.Deferred().resolve();
      }

      clearCartRequest
        .fail(addToCartFail)
        .done(function() {
          var checks = form.find('.chk-add:checked').toArray().reverse();
          var setIndex = form.find('.op-set-active').val();

          form.find('.op-bundle').val(new Date().getTime()+''+Math.floor(Math.random()*9999));

          $('#loading-overlay').show();
          if(modal) modal.close();

          function doItems() {
            var check = checks.pop();
            var index = check.value;

            var missingProperties = [];
            var htmlInputPresent = true;

            form.find('[data-name]').attr('name', null);

            form.find('.op-set-'+setIndex+' [data-name].op-item-'+index+', .op-set-common [data-name].op-item-'+index).each(function(ix, ctrl) {
              $(ctrl).attr('name', $(ctrl).data('name'));
            });

            try {
              $(window.pdpCustomOptions).each(function(ix, propertyName) {
                if (form.find('[name="properties[_'+propertyName+']"]').length==0) {
                  missingProperties.push(propertyName);

                  if (form.find('[data-name="properties[_'+propertyName+']"]').length==2) {
                    missingProperties[missingProperties.length-1] += '('+form.find('[data-name="properties[_'+propertyName+']"]')[index].value+')';
                  }

                  htmlInputPresent = htmlInputPresent && form.find('[data-name="properties[_'+propertyName+']"]').length==2;
                }
              });

              if (missingProperties.length>0) {
                var eyeName = '';

                try {
                  eyeName = form.find('[data-name="properties[_eye]"]')[index].value;
                } catch (e) {}

                var errMessage = 'Missing inputs for properties: '+missingProperties.join(', ')+'. Eye: '+eyeName+'. Inputs exist: '+(htmlInputPresent?'true.':'false.')+(meta.page.customerId ? ' CustomerId: '+meta.page.customerId+'.': '')+' User Agent: '+navigator.userAgent;

                ga('send', 'event', {
                  'eventCategory': 'MissingPropertiesError',
                  'eventAction': 'FormValidationFail',
                  'eventLabel': errMessage
                });
              }
            } catch (e) {}

            retryCartAdd(
              function() {
                return form.serialize();
              },
              function(jqXHR, textStatus, errorThrown) {
                try {
                  var responseIndex = jqXHR.properties._eye == 'Right' ? 1 : 0;

                  if (missingProperties.length == 0) {
                    $(window.pdpCustomOptions).each(function(ix, propertyName) {
                      if (typeof(jqXHR.properties['_'+propertyName])=='undefined') {
                        missingProperties.push(propertyName);

                        if (form.find('[data-name="properties[_'+propertyName+']"]').length==2) {
                          missingProperties[missingProperties.length-1] += '('+form.find('[data-name="properties[_'+propertyName+']"]')[responseIndex].value+')';
                        }

                        htmlInputPresent = htmlInputPresent && form.find('[data-name="properties[_'+propertyName+']"]').length==2;
                      }
                    });

                    if (missingProperties.length>0) {
                      var eyeName = '';

                      try {
                        eyeName = form.find('[data-name="properties[_eye]"]')[responseIndex].value;
                      } catch (e) {}

                      var errMessage = 'Missing inputs for properties: '+missingProperties.join(', ')+'. Eye: '+eyeName+'. Inputs exist: '+(htmlInputPresent?'true.':'false.')+(meta.page.customerId ? ' CustomerId: '+meta.page.customerId+'.': '')+' User Agent: '+navigator.userAgent;

                      ga('send', 'event', {
                        'eventCategory': 'MissingPropertiesError',
                        'eventAction': 'CartValidationFail',
                        'eventLabel': errMessage
                      });
                    }
                  }
                } catch (e) {}

                if (checks.length==0) {
                  addToCartSuccess(jqXHR, textStatus, errorThrown);
                } else {
                  doItems();
                }
              },
              addToCartFail,
              5
            );
          }

          doItems();
        });
    });
}

function loadCartJson() {
  $.getJSON('/cart.js').done(function(data){async_cart_json.resolve(data)});
}

function addToCartSuccess(jqXHR, textStatus, errorThrown){
  loadCartJson();
	updateCartDesc(null, jqXHR);
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  loadCartJson();

  console.log("add to cart failed", {
    status: jqXHR.status,
    textStatus: textStatus,
    errorThrown: errorThrown,
    responseText: jqXHR.responseText
  });

  $('#loading-overlay').hide();

  if (isShopifyVerificationResponse(jqXHR)) {
    Simplistic.openModal(
      '<div class="error-itemincart">We had trouble verifying your cart session. Please refresh the page and try checkout again.</div>',
      'message'
    );
    return;
  }

  var message = 'There was a problem adding this item to your cart. Please try again.';

  try {
    var response = $.parseJSON(jqXHR.responseText);
    if (response && response.description) {
      message = response.description;
    }
  } catch(e) {
    console.warn('Cart error response was not JSON', e);
  }

  Simplistic.openModal(
    '<div class="error-itemincart">' + message + '</div>',
    'message'
  );
}







function updateCartDesc(cart, itemAdded){

    if (window.addToCartCallback) {
      window.addToCartCallback(itemAdded);
      window.addToCartCallback = null;
    }

    return;
    /*

  	$.ajax({
		type: 'GET',
		url: '/cart?view=side-cart',
		cache: false,
      	success: function(data){
          	$('#loading-overlay').hide();

      		var animate = true;
          	if($('#side-cart').width()>0 && $('#side-cart').hasClass('open')) {
              	animate = false;
            }
          	$('#side-cart').remove();
          	$('#page').append(data);
          	if(modal) modal.close();
            

      	}
	  });
    */
}

function showSideCart(animate) {
  $('body, html').css({overflow: 'hidden'});
  $('#page').addClass('mode-overlay');
  if(animate) {
    setTimeout(function(){$('#side-cart').addClass('open')}, 100);
  } else {
    $('#side-cart').removeClass('ease-animation-slow');
  	$('#side-cart').addClass('open');
    setTimeout(function(){$('#side-cart').addClass('ease-animation-slow')}, 200);
  }
}

function hideSideCart() {
  $('#side-cart').removeClass('open');
  $('#page').removeClass('mode-overlay');
  $('body, html').css({overflow: ''});
}

function reChargeProcessCart(discount_multiplier, discount_code) {
	var discount = discount_multiplier!=1 ? '&discount='+encodeURIComponent(discount_code) : '';
    var checkout_url = "https://checkout.rechargeapps.com";
    function buildCheckoutUrl() {
        var t = ["myshopify_domain=" + Shopify.shop];
        return checkout_url + "/r/checkout?" + (t = t.concat(get_cart_token())).join("&") + discount
    }

    function filterVisible(t) {
        return t.filter(function(t) {
            return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
        })
    }

    function filterValues(t) {
        return t.filter(function(t) {
            var e = "radio" === t.getAttribute("type") && t.checked,
                n = "checkbox" === t.getAttribute("type") && t.checked,
                r = "checkbox" !== t.getAttribute("type") && "radio" !== t.getAttribute("type");
            return !!t.value && (r || e || n)
        })
    }

    function getCartJSON() {
        return fetch("/cart.js").then(function(t) {
            return t.json()
        }).then(function(t) {
            return {
                cart: JSON.stringify(t)
            }
        }).catch(function(t) {
            return console.error("Error retreiving cart: ", t), {
                cart: {}
            }
        })
    }

    function getTermsAndConditions() {
        var t = document.querySelectorAll(["#terms", "#agree"].join(",")),
            e = filterValues(Array.prototype.slice.apply(t)).map(function(t) {
                return t.value
            });
        return e.length ? {
            terms_and_conditions: e.join(", ")
        } : {}
    }

    function getNotes() {
        var t = document.querySelectorAll(['[name="note"]'].join(",")),
            e = filterVisible(Array.prototype.slice.apply(t)).map(function(t) {
                return t.value
            }),
            n = new URLSearchParams(decodeURIComponent(window.location.search)).get("note");
        return n && e.push(n), e.length ? {
            note: e.filter(function(t, e, n) {
                return n.indexOf(t) === e
            }).join(", ")
        } : ""
    }

    function getUTMAttributes() {
        var t = /^_shopify_sa_p/,
            e = /^utm_/,
            n = /^_shopify_sa_t/,
            r = {},
            o = "",
            i = "";
        document.cookie.split(";").map(function(t) {
            return t.trim()
        }).forEach(function(e) {
            t.test(e) && (o = e), n.test(e) && (i = decodeURIComponent(e.split("=")[1]))
        });
        var c = o.split("=")[1];
        if (decodeURIComponent(c).split("&").forEach(function(t) {
                var n = t.split("=")[0],
                    o = t.split("=")[1];
                if (e.test(n)) return r[n] = o
            }), Object.keys(r).length) return r.utm_timestamp = i, r.utm_data_source = "shopify_cookie", r
    }

    function getAttributes() {
        var t = /attributes\[(.*?)\]/,
            e = /\[(.*?)\]/,
            n = document.querySelectorAll(['[name*="attributes"]'].join(",")),
            r = filterValues(Array.prototype.slice.apply(n)),
            o = {},
            i = getUTMAttributes(),
            c = new URLSearchParams(decodeURIComponent(window.location.search));
        for (let n of c)
            if (t.test(n[0])) {
                var u = n[0].match(e)[0];
                u = u.substring(1, u.length - 1), o[u] = c.get(n[0])
            } return r.forEach(function(n) {
            var r = n.getAttribute("name"),
                i = n.value;
            if (t.test(r)) {
                var c = r.match(e)[0];
                return c = c.substring(1, c.length - 1), o[c] = i
            }
            return o[r] = i
        }), i && Object.keys(i).forEach(function(t) {
            o[t] = i[t]
        }), Object.keys(o).length ? {
            attributes: Object.assign({}, o)
        } : {}
    }

    function getCartData() {
        return getCartJSON().then(function(t) {
            var e = {};
            return [getTermsAndConditions(), getNotes(), getAttributes(), e = t].forEach(function(t) {
                Object.assign(e, t)
            }), e
        })
    }

    function get_cart_token() {
        try {
            return ["cart_token=" + (document.cookie.match("(^|; )cart=([^;]*)") || 0)[2]]
        } catch (t) {
            return []
        }
    }

    function get_ga_linker() {
        try {
            return [ga.getAll()[0].get("linkerParam")]
        } catch (t) {
            return []
        }
    }

    function buildInputs(t, e) {
        Object.keys(e).forEach(function(n) {
            var r = document.createElement("input");
            r.setAttribute("type", "hidden"), r.setAttribute("name", n), r.setAttribute("value", "object" == typeof e[n] ? JSON.stringify(e[n]) : e[n]), t.appendChild(r)
        })
    }

    function buildForm(t, e) {
        var n = document.createElement("form");
        return n.setAttribute("method", "post"), n.setAttribute("action", e), n.setAttribute("id", "rc_form"), n.style.display = "none", buildInputs(n, t), n
    }

    function hasSubscription(t) {
        return [...JSON.parse(t.cart).items].some(t => t.properties && t.properties.shipping_interval_unit_type)
    }

    function ReChargeCartSubmit() {
        return getCartData().then(function(t) {
            if (hasSubscription(t)) {
                var e = buildCheckoutUrl();
                if (t) {
                    var n = new XMLHttpRequest;
                    n.open("POST", "/cart/update.js"), n.setRequestHeader("Content-Type", "application/json"), n.onload = function() {
                        200 === n.status ? window.console.log("done", JSON.parse(n.responseText)) : 200 !== n.status && window.console.log("fail", JSON.parse(n.responseText));
                        var r = buildForm(t, e);
                        document.body.appendChild(r), r.submit()
                    }, n.send(JSON.stringify(t))
                } else window.location.href = e
            } else window.location.href = "/checkout"
        })
    }
    ReChargeCartSubmit();
}

window.SimplisticJS = function (){
  var Simplistic = this;
  this.formatMoney = "$\{\{amount\}\}";
  this.beforeTrapFocus = false;

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  this.trapFocus = function(options) {
    this.beforeTrapFocus = $(':focus');
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  this.removeTrapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }
    if(this.beforeTrapFocus) {
    	this.beforeTrapFocus.focus();
      	this.beforeTrapFocus = false;
    }

    $(document).off(eventName);
  }

  this.handleize = function (str) {
    //basic implementation
    //source https://gist.github.com/dlindenkreuz/a439ec4b939f0561d6d9
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  };

  this.getQueryParam = function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  this.randomstring = function(L){
    var s= '';
    var randomchar=function(){
      var n= Math.floor(Math.random()*62);
      if(n<10) return n; //1-10
      if(n<36) return String.fromCharCode(n+55); //A-Z
      return String.fromCharCode(n+61); //a-z
    }
    while(s.length< L) s+= randomchar();
    return s;
  }

  this.validateEmail = function(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
  }

  this.openModal = function(content, css, otherOptions) {
    var config = {
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      cssClass: [css],
      onOpen: function() {
        $(".tingle-modal__close").appendTo(".tingle-modal-box__content");
      }
    };
    if (otherOptions) {
      $.extend(config, otherOptions);
    }
    modal = new tingle.modal(config);
    modal.setContent(content);
    modal.open();
    return modal;
  }

  this.onImagesLoaded = function(images, callback){
    var imagesLoaded = 0;
    images.each(function(){
      var img = new Image();
      img.onload = function() {
        imagesLoaded++;
        if(imagesLoaded==images.length) {
          callback();
        }
      };
      img.src = $(this).attr('data-src');      
    });

  };

  this.utm = new function() {
    var utm_storage = localStorage;
    var expiration = 86400000 * 7;
    var source = Simplistic.getQueryParam('utm_source') || Simplistic.getQueryParam('utm_medium');
    if (source) {
      if (location.href.indexOf('?')==-1) {
        console.error('BAD UTM DATA:\nURL malformed, missing \'?\' character.');
      }
      utm_storage.setItem('sjs_utm', JSON.stringify({href: location.href, time: new Date().getTime()}));
    }
    this.get = function() {
      var strdata = utm_storage.getItem('sjs_utm');
      var data = null;
      if (strdata) {
        data = JSON.parse(strdata);
        if (data.time + expiration < new Date().getTime()) {
          localStorage.removeItem('sjs_utm');
          return null;
        }
      }
      return data;
    }
    this.delete = function() {
      utm_storage.removeItem('sjs_utm');
    }
    return {get:this.get,delete:this.delete};
  };

  this.DiscountsByFrequency = {};
  
  
    
    
    
    this.DiscountsByFrequency['30'] = {
      "days": 30,
      "title": "Monthly",
      "discountCode": "FIRSTORDER_10%OFF",
    }
  
    
    
    
    this.DiscountsByFrequency['60'] = {
      "days": 60,
      "title": "Bi-Monthly",
      "discountCode": "CC_FIRSTORDER_35%OFF_210107ST",
    }
  
    
    
    
    this.DiscountsByFrequency['90'] = {
      "days": 90,
      "title": "Quarterly",
      "discountCode": "CC_FIRSTORDER_40%OFF_1130",
    }
  
    
    
    
    this.DiscountsByFrequency['120'] = {
      "days": 120,
      "title": "Four Months",
      "discountCode": "CC_FIRSTORDER_15%OFF_210107",
    }
  
    
    
    
    this.DiscountsByFrequency['180'] = {
      "days": 180,
      "title": "Bi-Annually",
      "discountCode": "CC_FIRSTORDER_25%OFF_210107S",
    }
  
    
    
    
    this.DiscountsByFrequency['360'] = {
      "days": 360,
      "title": "Annually",
      "discountCode": "CC_FIRSTORDER_15%OFF_210107",
    }
  

  this.CrossSells = {
    items: [],
    itemsByProduct: {},
    findCandidates: function(addedProduct) {
      if (this.itemsByProduct[addedProduct.id]) {
        return this.itemsByProduct[addedProduct.id];
      } else {
        var ret = [];
        this.items.forEach(function(item) {
          if (item.type=='cross_sell_item') {
            if (item.settings.product_tag && addedProduct.tags.indexOf(item.settings.product_tag)>=0) {
              ret.push(item);
            }
          }
        });
        return ret;
      }
    },
    //options: (required) with required and optional settings
    //options.onAccept: (required), handler called when user clicks Add To Cart
    //options.onNo: (required), handler called when user clicks No thanks
    //options.items: (optional), array of items to show
    showPopup: function(addedProduct, options) {
      if (typeof(options)!='object') {
        console.error('Cross & Up sells popup requires options parameter');
        return;
      }
      if (typeof(options.onAccept)!='function') {
        console.error('Cross & Up sells popup requires options.onAccept parameter');
        return;
      }
      if (typeof(options.onNo)!='function') {
        console.error('Cross & Up sells popup requires options.onNo parameter');
        return;
      }
      var offerItems = options.items;
      if (typeof(offerItems)=='undefined') {
        offerItems = this.findCandidates(addedProduct);
      }
      var content = $('<div class="content"></div>');
      var titlePlaceHolder = $('<div class="popup-title"></div>');
      var itemsContainer = $('<div class="items slick-pending"></div>');
      if (offerItems.length>1)
        itemsContainer.addClass('multiple');
      offerItems.forEach(function(offerItem) {
        var img = '';
        var variant;
        for (var i=0; i<offerItem.product.variants.length; i++) {
          if (offerItem.product.variants[i].available) {
            variant = offerItem.product.variants[i];
            break;
          }
        }
        var wrapContent = '<div class="product-title">'+offerItem.product.title+'</div><div class="variant" data-variantid="'+variant.id+'"><div class="price">'+Shopify.formatMoney(variant.price, Simplistic.formatMoney)+'</div></div>';
        offerItem.selected_variant_id = variant.id;
        if (offerItem.product.images.length > 0) {
          img = '<img src="'+offerItem.product.images[0]+'" />';
        }
        if (offerItem.settings.description) {
          wrapContent += '<div class="description">'+offerItem.settings.description+'</div>';
        }
        var item = $('<div class="item"></div>');
        var slideTitle = $('<div class="slide-title">'+offerItem.settings.title+'</div>');
        item.append(slideTitle);
        var itemGrid = $('<div class="grid"><div class="grid__item image" >'+img+'</div></div>')
        var wrap = $('<div class="grid__item wrap">'+wrapContent+'</div>');
        var buttonsContainer = $('<div class="actions"></div>');
        item.append(itemGrid);
        itemsContainer.append(item);
        item.data('title', offerItem.settings.title);
        itemGrid.append(wrap);
        wrap.append(buttonsContainer);

        var buttonOk = $('<button type="button" class="btn btnv3 btn-ok">Add To Cart</button>');
        var buttonNo = $('<button type="button" class="btn btnv3 btn-no">No Thanks</button>');
        buttonsContainer.append(buttonOk).append(buttonNo);
        buttonOk.click(function() {
          try {
            if (modal)
              modal.close();
          } catch (e) {}
          options.onAccept({
            "item": offerItem,
            "accepted": true
          })
        });
        buttonNo.click(function() {
          try {
            if (modal)
              modal.close();
          } catch (e) {}
          if (options.onNo) {
            options.onNo({
              "item": offerItem,
              "accepted": false
            })
          }
        });
      });
      content.append(titlePlaceHolder);
      content.append(itemsContainer);
      var modal = Simplistic.openModal(content, 'cross-up-sells-popup', {
        closeMethods: ['button'],
        beforeClose: function() {
          Simplistic.removeTrapFocus({
            $container: $('#cross-up-sells-popup'),
            namespace: 'cross-up-sells-popup'
          });
          return true;
        }
      });
      Simplistic.trapFocus({
        $container: $('.cross-up-sells-popup'),
        namespace: 'cross-up-sells-popup'
      });

      $('.cross-up-sells-popup').click(function(event) {
        if (event.target == this) {
          modal.close();
          modal = null;
          itemsContainer.find('.slick-current .btn-no').click();
        }
      });
      $('.cross-up-sells-popup .tingle-modal__close').click(function(event) {
        modal = null;
        itemsContainer.find('.slick-current .btn-no').click();
      });
      itemsContainer.slick({
        autoplay: false,
        speed: 700,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<i class="lnr lnr-chevron-left left-arrow animation"></i>',
        nextArrow: '<i class="lnr lnr-chevron-right right-arrow animation"></i>',
        centerMode: offerItems.length>1,
        centerPadding: '6.4em',
        responsive: [
          {
              breakpoint: 900,
              settings: {
                arrows: false
              }
          },
          {
              breakpoint: 600,
              settings: {
                centerPadding: '2.6em',
                arrows: false
              }
          }
        ]
      });
      itemsContainer.on('afterChange', function(event, slick, currentSlide){
        setPopupTitle(currentSlide)
      });
      function setPopupTitle(index) {
        titlePlaceHolder.html(offerItems[index].settings.title);
      }
      setPopupTitle(0);
    }

  }

  this.DiscountsByTag = {};
  this.DiscountsByTag['default-tag'] = {
    "discountMultiplier": 1,
    "discountCode": "",
    "annualDiscountMultiplier": 1,
    "annualDiscountCode": ""
  };

  

    this.DiscountsByTag["fod60"] = {
      "discountMultiplier": parseFloat("0.4"),
      "discountCode": "CC_FIRSTORDER_60%OFF_21330CB",
      "annualDiscountMultiplier": parseFloat("0.4"),
      "annualDiscountCode": "ONETIMEANNUAL5PERCENTOFF"
    };
    
  

    this.DiscountsByTag["fod20"] = {
      "discountMultiplier": parseFloat("0.8"),
      "discountCode": "FIRSTORDER_20%OFF",
      "annualDiscountMultiplier": parseFloat("0.8"),
      "annualDiscountCode": "ONETIMEANNUAL5PERCENTOFF"
    };
    
  

    this.DiscountsByTag["fod35"] = {
      "discountMultiplier": parseFloat("0.65"),
      "discountCode": "FIRSTORDER_35%OFF",
      "annualDiscountMultiplier": parseFloat("0.65"),
      "annualDiscountCode": "FIRSTORDER_35%OFF"
    };
    
  

    this.DiscountsByTag["FOD30"] = {
      "discountMultiplier": parseFloat("0.7"),
      "discountCode": "FOD30",
      "annualDiscountMultiplier": parseFloat("0.7"),
      "annualDiscountCode": "FOD30"
    };
    
  

    this.DiscountsByTag["fod40"] = {
      "discountMultiplier": parseFloat("0.6"),
      "discountCode": "CC_FIRSTORDER_40%OFF_1130",
      "annualDiscountMultiplier": parseFloat("0.6"),
      "annualDiscountCode": "CC_FIRSTORDER_40%OFF_1130"
    };
    
  

    this.DiscountsByTag["fod25"] = {
      "discountMultiplier": parseFloat("0.75"),
      "discountCode": "FIRSTORDER_25%OFF",
      "annualDiscountMultiplier": parseFloat("0.75"),
      "annualDiscountCode": "ONETIMEANNUAL5PERCENTOFF"
    };
    
  
};

window.Simplistic = new SimplisticJS();
function gtag_report_conversion(send_to, url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': send_to,
      'event_callback': callback
  });
  return false;
}

function pdp_setupProductSpecs() {
  var $grid = $('.product-specs .grid');
  var specs = $('.product-specs .description .specs');
  $grid.append(specs.html());
  $grid.addClass('cols'+($grid.find('.grid__item').length) );
  $grid.find('.grid__item').addClass('medium--one-half small--one-whole').each(function(ix, gi){
    if (ix>0)
      $(gi).before('<div class="grid__item col-sep-'+ix+'"></div>');

    $(gi).addClass('col-'+(ix+1));
  });
}
function pdp_setupPDPJS() {
  pdp_setupProductSpecs();
  var newStep = null;
  $('.step-root').each(function(ix, step){
    $(step).on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(event){
      if (event.target==step && newStep!=step) {
        $(step).hide();
        $(newStep).show();
        setTimeout(function(){
          $(newStep).removeClass('step-hidden');

          //refresh widgets and other step specific content

          if ($(newStep).hasClass('step-1')) {
            $('#product-wrap .thumbs').slick('setPosition');
          }
        },1);
      }
    })
  });

  var confirmedPowerPlus = false;
  var allowConfirmOnContinue = false;
  var hotjarStep2EventSent = false;
  var hotjarStep3EventSent = false;
  var hotjarDoctorSearchEventSent = false;
  var hotjarDoctorNotListedEventSent = false;
  var hotjarCheckoutEventSent = false;
  var hotjarDoctorSearchTypingEventSent = false;

  function validateStep1() {
    //return true;

    // if (!window.rechargeLoadComplete) {
    //   //Simplistic.openModal('<div class="error-itemincart"><p>ReCharge Subscription Manager is still loading</p></div>');
    //   return false;
    // }

    var form = $('#product-wrap .add-to-cart-form');
    var checks = form.find('.chk-add:checked').toArray();
    var setIndex = form.find('.op-set-active').val();
    var ok = true;
    var mustConfirmPowerPlus = false;

    $(checks).each(function(i, check){
      var index = check.value;
      form.find('select.op-item-'+index).each(function(ix, select){
        var $select = $(select);
        if ($select.val()=="") {
          $select.addClass('error');
          $select.closest('.op-field').find('.select-simulator').addClass('error');
        }

        if ($select.data('name') == "properties[_power]" && select.value.startsWith('+') ) {
          mustConfirmPowerPlus = true;
        }
      });
      if (form.find('.op-set-'+setIndex+' select.error').length>0)
        ok = false;
    })

    if (!ok) {
      //$('.error-message.step-message').html('Please, complete all STEP 1 fields');
      return false;
    }
    var popMsg = null;

    if ($('.pop-confirm-power').closest('.popover').css('display')=='block' && allowConfirmOnContinue) {
      //confirm automatically if clicked on Continue and popover is already visible
      confirmedPowerPlus = true;
    }

    if (!confirmedPowerPlus && mustConfirmPowerPlus) {
      popMsg = $('<div class="pop-confirm-power"><div class="text">Make sure you meant to choose + power, not -</div> <button class="btn btnv3 color-invert confirm">Confirm</button></div>');
    }

    if (popMsg) {
      var popover = $('.step-1-confirm');
      popover.html(popMsg);
      popover.fadeIn({
        complete: function() {
          popover.focus();
          allowConfirmOnContinue = true;
          var handler = function(event) {
            if ($(event.target).closest('.popover').length == 0) {
              hidePopOver();
            }
          }
          function hidePopOver() {
            $(document).off('click', handler);
            popover.hide();
            //popover.html('');
          }

          popMsg.find('button.confirm').on('click', function (event){
            event.preventDefault();
            confirmedPowerPlus = true;
            hidePopOver();
            $('[data-stepdst="step-2"].btn-step-changer').first().click();
            return false;
          });

          $(document).on('click', handler);
        }
      });
      return false;
    }
    return true;
  }

  function validateStep2() {
    var ok = true;
    var st = $('.state-selector select');
    if (st.val()=="") {
      st.addClass('error');
      ok = false;
    } else {
      st.removeClass('error');
    }
    if ($('.doctor #find-doctor').val()=="") {
      ok = false;
      $('.doctor .selectize-input').addClass('error');
    } else {
      $('.doctor .selectize-input').removeClass('error');
    }

    if (!ok) {
      $('.error-message.step-message').html('Please, complete all STEP 2 fields');
      return false;
    }

    return true;
  }

  function validateStep3() {
    var frequencySelcted = $('.step-root.step-3 [name="frequency-option"]:checked');
    var errmsg = $('.error-message.step-message');
    errmsg.html('');
    if (frequencySelcted.length==0) {
      errmsg.html('Please select a subscription plan');
      return false;
    }

    return true;
  }

  function validateDoctorPopUp() {
    var ok = true;
    var doctor = $('.new-doctor-popup [name=doctor]');

    if (doctor.val().trim()=="") {
      ok = false;
      doctor.addClass('error');
    } else {
      doctor.removeClass('error');
    }

    var city = $('.new-doctor-popup [name=city]');
    if (city.val().trim()=="") {
      ok = false;
      city.addClass('error');
    } else {
      city.removeClass('error');
    }

    if (!ok) {
      $('.error-message.popup-message').html('Please, complete all fields');
      return false;
    }

    return true;
  }

  function isOneTime() {
    return !($('#product-wrap .add-to-cart-form [name="purchase_type"][value="autodeliver"]').prop('checked'));
  }

  function getFrequency() {
    return $('#product-wrap .add-to-cart-form #rc_autodeliver_options input, #product-wrap #rc_autodeliver_options select').first().val();
  }

  function updateBillingAndFrequency() {
    var freqDdl = $('#product-wrap .add-to-cart-form [name=properties\\[shipping_interval_frequency\\]]')[0];
    var unitTypeEl = $('#product-wrap .add-to-cart-form [data-id="rc_shipping_interval_unit_type"]')[0];
    if (!freqDdl && !unitTypeEl) return;
    var onetime = false;
    $('#product-wrap .add-to-cart-form [name="quantity"]').val(1);
    var quantity = $('#product-wrap .add-to-cart-form [name="quantity"]').val();
    var numberEyes = $('#chk-is-oneeye').prop('checked') ? 1 : 2;
    var discount_tag = $('#product-wrap .add-to-cart-form').data('discount-tag');
    var discount_multiplier = Simplistic.DiscountsByTag[discount_tag].discountMultiplier;
    var annual_discount_multiplier = Simplistic.DiscountsByTag[discount_tag].annualDiscountMultiplier;
    var nextOrderPrice = null;
    var nextOrderPriceValue = null;
    var price = null;
    var currentPrice = parseFloat(($('#product-wrap .add-to-cart-form .js-price-wrapper .js-price').html() || '').replace('$', '')) || null;

    if (discount_multiplier != 1) {
      nextOrderPrice = $('#product-wrap .add-to-cart-form .js-retail span').html();
      nextOrderPriceValue = parseFloat(nextOrderPrice.replace('$',''));
      price = nextOrderPriceValue * quantity * (onetime ? annual_discount_multiplier : discount_multiplier);
    } else {
      nextOrderPrice = $('#product-wrap .add-to-cart-form .js-price').html();
      nextOrderPriceValue = parseFloat(nextOrderPrice.replace('$',''));
      price = nextOrderPriceValue * quantity * (onetime ? annual_discount_multiplier : 1);
    }


    var freqDdl = $('#product-wrap .add-to-cart-form [name=properties\\[shipping_interval_frequency\\]]')[0];
    if (freqDdl && freqDdl.options) {
      var freq = freqDdl.options[freqDdl.selectedIndex].text
    }
    else {
      var freq = getFrequency() + ' ' + $('#product-wrap .add-to-cart-form [data-id="rc_shipping_interval_unit_type"]')[0].value;
    }
    if (window.pdpShowFrequencySelection !== false) {
      var step3 = $('.step-root.step-3');
      var frequencyItems = step3.find('.frequency-item');
      var unit = step3.find('[data-frequency-unit]').data('frequency-unit').toLowerCase();
      var unitMultiplier;
      if (unit.indexOf('day')>-1) {
        unitMultiplier = 1;
      } else if (unit.indexOf('week')>-1) {
        unitMultiplier = 4.35;
      } else if (unit.indexOf('month')>-1) {
        unitMultiplier = 30;
      }
      var minFrequencyItem = frequencyItems.first();
      var minDays = minFrequencyItem.data('frequency') * unitMultiplier;
      var bestValueItem;
      var maxSavings = 0;

      frequencyItems.each(function(ix, freqItem) {
        freqItem = $(freqItem);
        var days = freqItem.data('frequency') * unitMultiplier;
        var itemQuantity = Math.round(days / minDays);
        var daysKey = (Math.round(days / 30) * 30) + '';
        var numMonths = Math.round(days / 30);
        var input = freqItem.find('input');
        var title = freqItem.find('.item-title');
        var unitPrice = freqItem.find('.unit-price');
        var origPrice = freqItem.find('.orig-price');
        var itemDiscount = freqItem.find('.item-discount');
        var valueOff = freqItem.find('.value-off');
        var valueSave = freqItem.find('.value-save');
        var billingFrequency = freqItem.find('.item-billing-frequency');
        input.val(itemQuantity)
        var dCode;
        var uPrice;
        var dPercent;
        var dMultiplier;
        var savings;
        if (ix==0) {
          dCode = Simplistic.DiscountsByTag[discount_tag].discountCode;
          uPrice = price;
          dMultiplier = Simplistic.DiscountsByTag[discount_tag].discountMultiplier;
        } else {
          dCode = Simplistic.DiscountsByFrequency[daysKey].discountCode;
          uPrice = nextOrderPriceValue * Simplistic.DiscountsByFrequency[daysKey].discountMultiplier;
          dMultiplier = Simplistic.DiscountsByFrequency[daysKey].discountMultiplier;
        }
        dPercent = 100 - dMultiplier * 100;
        var qtyBoxes = itemQuantity * numberEyes;
        var uPriceFormatted = Shopify.formatMoney(Math.floor(uPrice * 100), Simplistic.formatMoney).replace('.00', '');
        var totalPriceFormatted = Shopify.formatMoney(Math.floor(uPrice * 100 * qtyBoxes), Simplistic.formatMoney).replace('.00', '');
        var totalNextOrderFormatted = Shopify.formatMoney(nextOrderPriceValue * 100 * qtyBoxes, Simplistic.formatMoney).replace('.00', '');
        savings = Math.round( (nextOrderPriceValue - uPrice) * qtyBoxes );
        if (savings > maxSavings) {
          maxSavings = savings;
          bestValueItem = freqItem;
        }
        if (savings == 0) {
          origPrice.hide();
          itemDiscount.hide();
        } else {
          origPrice.show();
          itemDiscount.show();
        }
        freqItem.data('discount-multiplier', dMultiplier);
        freqItem.data('discount-code', dCode);
        valueOff.html(dPercent + '% Off');
        valueSave.html(Shopify.formatMoney(savings * 100, Simplistic.formatMoney).replace('.00', '')+' off');
        //unitPrice.html(uPriceFormatted);
        unitPrice.html(totalPriceFormatted);
        freqItem.data('quantity', itemQuantity);
        //origPrice.html(nextOrderPrice);
        origPrice.html(totalNextOrderFormatted);

        title.html(numMonths + ' Month Supply');
        billingFrequency.html(qtyBoxes + ' ' + ($('.step-1 [data-pack-size]').data('pack-size')) + (qtyBoxes==1 ? '-pack' : '-packs') +' <br class="hide large--show" />shipped '+(numMonths==1 ? 'monthly' : 'every '+numMonths+' months') )

        if (input[0].checked) {
          quantity = itemQuantity;
          $('#product-wrap .add-to-cart-form [name="quantity"]').val(quantity);
          discount_multiplier = dMultiplier;
          freq = freqItem.data('frequency') + ' ' + unit;
          $('#product-wrap .add-to-cart-form [name="properties[shipping_interval_frequency]"]').val(freqItem.data('frequency'));
          if (freq == '1 months') {
            freq == '1 month';
          }
        }

      });

      price = nextOrderPriceValue * quantity * discount_multiplier;
      nextOrderPriceValue = nextOrderPriceValue * quantity;
      nextOrderPrice = '$' + (nextOrderPriceValue).toFixed(2);

      if (bestValueItem) {
        var badge = frequencyItems.find('.badge').first();
        bestValueItem.find('label').prepend(badge);
      }
    }

    price = '$' + (((currentPrice || price)*numberEyes*100)/100).toFixed(2);
    nextOrderPrice = '$' + (nextOrderPriceValue * numberEyes).toFixed(2);

    

    
    if (freq.indexOf('Month')>-1) {
      var daysQty = Math.round(freq.split(' ')[0] * 30);
      freq = daysQty + ' Days';
    } else if (freq.indexOf('Week')>-1) {
      var daysQty = Math.round(freq.split(' ')[0] * 7);
      freq = daysQty + ' Days';
    }

    if (onetime) {
      
      $('.bill-msg').html('');
    } else {
      if (discount_multiplier != 1) {
        var discountPercentage = Math.floor( 100 - (100* discount_multiplier));
        $('.bill-msg').html(price + '  for your first order (after '+discountPercentage+'% off) and then '+nextOrderPrice+' every ' + freq.toLowerCase());
      } else {
        $('.bill-msg').html(price + '  every ' + freq.toLowerCase());
      }
    }

  }

 $('.btn-step-changer').on('click', function(event, pOptions){
    clearErrors();
    var options = $.extend({}, {scroll: false}, pOptions);
    var btn = $(this);
    var str = btn.closest('.step-root');
    var stepDst = $('.'+btn.data('stepdst'));
    //apply validations first
    if (btn.hasClass('btn-next')) {

      if (str.hasClass("step-1") && !validateStep1()) {
        if (options.scroll) {
          var of = $('.step-1 .step-main-button').offset();
          var h = $( window ).height();
          $("html, body").animate({ scrollTop: of.top-h+120 }, 600);
        }
        return;
      }
      if (btn.hasClass('btn-popup')) {
        str = $('.step-root.step-2');
        if (!validateDoctorPopUp()) {
          return;
        }
        stepDst.find('.btn-checkout').addClass('btn-popup');
        window.modal.close();
      } else if (str.hasClass("step-2")) {
        if (!validateStep2()) {
          return;
        }
        stepDst.find('.btn-checkout').removeClass('btn-popup');
      }

      if (str.hasClass("step-1")) {
        // ga('send', 'event', 'Button', 'click', 'Enter Prescription');
        gtag_report_conversion('AW-763370030/Idu5COvAnpYBEK60gOwC')
        
        if (window.pdpShowFrequencySelection !== false) {
          var step2 = $('.step-root.step-2');
          if (!step2.hasClass('initialized')) {
            step2.addClass('initialized');
            step2.find('.summary').remove();
            step2.find('.btn-checkout').remove();
            step2.find('.btn-next.btn-step-changer').show();
            var step3 = $('.step-root.step-3');
            step3.find('input:radio').change(function() {
              updateBillingAndFrequency();
              step3.find('.summary').slideDown();
              validateStep3();
            });
          }
        }

        // Wait for ReCharge to render before calling
        $(document).one('rca:ready', function() {
          updateBillingAndFrequency();
        });

        // Fallback in case rca:ready already fired or never fires
        setTimeout(function() {
          var freqDdl = $('#product-wrap .add-to-cart-form [name=properties\\[shipping_interval_frequency\\]]')[0];
          var unitTypeEl = $('#product-wrap .add-to-cart-form [data-id="rc_shipping_interval_unit_type"]')[0];
          if (freqDdl || unitTypeEl) {
            updateBillingAndFrequency();
          }
        }, 1500);
      }
    }
    //end validations

    $("html, body").animate({ scrollTop: 0 }, 300);
    newStep = stepDst[0];
    str.addClass('step-hidden');

    if (!hotjarStep2EventSent && btn.data('stepdst')=='step-2') {
      hotjarStep2EventSent = true;
      //Hotjar track view
      hj('vpv', '/pdp-'+btn.data('stepdst')+'/');
    }
    if (!hotjarStep3EventSent && btn.data('stepdst')=='step-3') {
      hotjarStep3EventSent = true;
      //Hotjar track view
      hj('vpv', '/pdp-'+btn.data('stepdst')+'/');
    }
  });


  $('.doctor-not-listed').on('click', function(event){
    clearErrors();
    Simplistic.openModal($('.new-doctor-popup'), 'product-wrap');
    if (!hotjarDoctorNotListedEventSent) {
      hotjarDoctorNotListedEventSent = true;
      //Hotjar track view
      hj('vpv', '/doctor-not-listed/');
    }
  });

  function clearErrors() {
    $('.error-message').html('');
    $('#product-wrap .error').removeClass('error');
  }

  $('.btn-checkout').on('click', function(event) {
    clearErrors();
    var btn = $(this);
    var doctor = '';
    var doctorId = '';
    var clinic = '';
    var city = '';

    //validate all required data; return false
    if (!validateStep1()) {
      return false;
    }

    if (btn.hasClass('btn-popup')) {
      if (!validateDoctorPopUp()) {
        return false;
      }
    }
    else {
      if (!validateStep2()) {
        return false;
      }
    }

    if (window.pdpShowFrequencySelection !== false) {
      if (!validateStep3()) {
        return false;
      }
    }

    function checkout() {
      var doctor = '';
      var doctorId = '';
      var clinic = '';
      var city = '';

      if (btn.hasClass('btn-popup')) {
        doctor = $('.new-doctor-popup [name=doctor]').val();
        doctorId = $('.new-doctor-popup [name=doctorid]').val();
        clinic = '';
        city = $('.new-doctor-popup [name=city]').val();
      }
      else {
        var data = $('#find-doctor')[0].selectize.options[$('#find-doctor').val()];
        doctor = data.name;
        doctorId = $('#find-doctor').val();
        clinic = data.clinic_name;
        city = data.city;
      }

      var form = $('#product-wrap .add-to-cart-form');
      $('[name="properties\\[_doctor_state\\]"]').val($('.state-selector select').val());
      $('[name="properties\\[_doctor_id\\]"]').val(doctorId);
      $('[name="properties\\[_doctor_name\\]"]').val(doctor ? doctor.trim() : '');
      $('[name="properties\\[_doctor_clinic\\]"]').val(clinic ? clinic.trim() : '');
      $('[name="properties\\[_doctor_city\\]"]').val(city ? city.trim() : '');
      var discount_tag = form.data('discount-tag');
      var discount_multiplier = Simplistic.DiscountsByTag[discount_tag].discountMultiplier;
      var discount_code = Simplistic.DiscountsByTag[discount_tag].discountCode;
      var annual_discount_code = Simplistic.DiscountsByTag[discount_tag].annualDiscountCode;

      if (window.pdpShowFrequencySelection) {
        var freqItem = $('.step-root.step-3 input:checked').closest('.frequency-item');
        discount_multiplier = freqItem.data('discount-multiplier');
        discount_code = freqItem.data('discount-code');
      }

      $('[name="properties\\[_discount_code\\]"]').val(discount_code);


      window.addToCartCallback = function(itemAdded) {
        //if (itemAdded.properties.hasOwnProperty('subscription_id'))
        var onetime = isOneTime();
        async_cart_json.done(function(cart) {
          // var pintrkData = {
          //   value: cart.total_price/100,
          //   order_quantity: cart.item_count,
          //   currency: cart.currency,
          //   line_items: []
          // }
          // cart.items.forEach(function(item) {
          //   var line_item = {
          //     product_name: item.product_title,
          //     product_id: item.product_id,
          //     product_price: item.line_price/100,
          //     product_quantity: item.quantity,
          //     product_brand: item.product_type
          //   };
          //   pintrkData.line_items.push(line_item);
          // });

          // track_pintrk('AddToCart', pintrkData);

          function forwardToCheckout() {
            if (onetime) {
              if (annual_discount_code) {
                if (Cookies.get('discount_code')!=annual_discount_code) {
                  $.get('/discount/'+annual_discount_code).done(function(){
                    location = "/checkout";
                  });
                } else {
                  location = "/checkout";
                }
              } else {
                location = "/checkout";
              }
            }
            else
              reChargeProcessCart(discount_multiplier, discount_code);
          }

          var crossSellItems = [];

          if (window.pdpShowUpsellProducts) {
            var addedProduct = window.productJs.getProduct();
            crossSellItems = Simplistic.CrossSells.findCandidates(addedProduct);
          }

          if (crossSellItems.length>0) {
            $('#loading-overlay').hide();
            Simplistic.CrossSells.showPopup(addedProduct, {
              items: crossSellItems,
              onNo: function(response){
                console.log('No thanks on item', response);
                forwardToCheckout();
              },
              onAccept: function(response){
                var self = this;
                var data = {"id": response.item.selected_variant_id, "quantity": 1, "properties": {"_oneoff": "true"}};
                $('#loading-overlay').show();
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: data,
                  dataType: 'json',
                  error: function(jqXHR, textStatus, errorThrown) {
                    addToCartFail(jqXHR, textStatus, errorThrown);
                    $('#loading-overlay').hide();
                  },
                  success: function(jqXHR, textStatus, errorThrown) {
                    //$('#loading-overlay').hide();
                    forwardToCheckout();
                  },
                  cache: false
                });
              }
            });
          } else {
            forwardToCheckout();
          }

        });
      }


      form.find('[name="add"]')[0].click();
    } //end function checkout

    if (btn.hasClass('btn-popup')) {
      var data = {
        "name": $('.new-doctor-popup [name=doctor]').val(),
        "clinic_name": '',
        "state": $('.state-selector select').val(),
        "city": $('.new-doctor-popup [name=city]').val()
      }

      $('#loading-overlay').show();
      $.ajax({
        type: 'POST',
        url: 'https://api.hubblecontacts.com/v1/docs/create.js',
        data: data,
        dataType: 'jsonp',
        error: function(jqXHR) {
          console.error({'Error': 'Couldn\'t create doctor entry', 'Data': jqXHR});
          $('#loading-overlay').hide();
        },
        success: function(jqXHR, textStatus, errorThrown) {
          $('.new-doctor-popup [name=doctorid]').val(jqXHR.data.doc.id);
          checkout();
        },
        cache: false
      });
    } else {
      $('#loading-overlay').show();
      checkout();
    }
    ga('send', 'event', 'Button', 'click', 'Find Your Doctor');
    gtag_report_conversion('AW-763370030/rrBLCNees5YBEK60gOwC')

    if (!hotjarCheckoutEventSent) {
      hotjarCheckoutEventSent = true;
      //Hotjar track view
      hj('vpv', '/checkout-clicked/');
    }

  });

  $('.frequency-selector').on('click', function(event){
    var $this = $(this);
    $this.parent().find('.frequency-selector.selected').removeClass('selected');
    $this.addClass('selected');
    if (typeof(showOptionsSet)!='undefined')
      showOptionsSet($this.data('index'));
  });
  //$('.frequency-selector').first().click();
  $('.frequency-selector .purchase-options .item').first().click();


  var states = [['',''],['AL','ALABAMA'],['AK','ALASKA'],['AZ','ARIZONA'],['AR','ARKANSAS'],['CA','CALIFORNIA'],['CO','COLORADO'],['CT','CONNECTICUT'],['DE','DELAWARE'],['DC','DISTRICT OF COLUMBIA'],['FL','FLORIDA'],['GA','GEORGIA'],['HI','HAWAII'],['ID','IDAHO'],['IL','ILLINOIS'],['IN','INDIANA'],['IA','IOWA'],['KS','KANSAS'],['KY','KENTUCKY'],['LA','LOUISIANA'],['ME','MAINE'],['MD','MARYLAND'],['MA','MASSACHUSETTS'],['MI','MICHIGAN'],['MN','MINNESOTA'],['MS','MISSISSIPPI'],['MO','MISSOURI'],['MT','MONTANA'],['NE','NEBRASKA'],['NV','NEVADA'],['NH','NEW HAMPSHIRE'],['NJ','NEW JERSEY'],['NM','NEW MEXICO'],['NY','NEW YORK'],['NC','NORTH CAROLINA'],['ND','NORTH DAKOTA'],['OH','OHIO'],['OK','OKLAHOMA'],['OR','OREGON'],['PA','PENNSYLVANIA'],['PR','PUERTO RICO'],['RI','RHODE ISLAND'],['SC','SOUTH CAROLINA'],['SD','SOUTH DAKOTA'],['TN','TENNESSEE'],['TX','TEXAS'],['VI', 'U.S. Virgin Islands'],['UT','UTAH'],['VT','VERMONT'],['VA','VIRGINIA'],['WA','WASHINGTON'],['WV','WEST VIRGINIA'],['WI','WISCONSIN'],['WY','WYOMING']];
  var statesDdl = $('.state-selector select')[0];
  $(states).each(function(ix,name) {
    if($.isArray(name)){
      statesDdl.options.add(new Option(name[1], name[0]));
      $(statesDdl.options[ix]).data('json', {"name": name[1]});
    }else{
      statesDdl.options.add(new Option(name, name));
      $(statesDdl.options[ix]).data('json', {"name": name});
    }
  })
  $(statesDdl).on('change', function(){
    //clear doctor selection
    $selectFindDoctor[0].selectize.clear();
    $selectFindDoctor[0].selectize.destroy();
    $selectFindDoctor = $('#find-doctor').selectize(selectizeConfig);

    var icon = $(statesDdl).closest('.select-wrapper').find('.icon');
    if (this.value!="") {
      icon.fadeIn();
      $('.doctor').slideDown();
      if (!hotjarDoctorSearchEventSent) {
        hotjarDoctorSearchEventSent = true;
        //Hotjar track view
        hj('vpv', '/doctor-search/');
      }
    } else {
      icon.fadeOut();
      $('.doctor').slideUp();
    }
  });
  $('#find-doctor').on('change', function(){
    var icon = $(this).closest('.select-wrapper').find('.icon');
    if ($(this).val()!="") {
      $('.step-2 .summary').slideDown({
        complete: function() {
          /*
          //for summary above checkout
          var of = $('.step-2 .step-main-button').offset();
          var h = $( window ).height();
          $("html, body").animate({ scrollTop: of.top-h+120 }, 600);
          */

          /*
          //for summary below checkout, i think is not needed
          var of = $('.step-2 .step-main-button').offset();
          $("html, body").animate({ scrollTop: of.top-140 }, 600);
          */
        }
      });
      icon.fadeIn();
    } else {
      $('.step-2 .summary').slideUp();
      icon.fadeOut();
    }
  });
  $('.frequency-option .purchase-options .item').on('click', function(event) {
    //change frequency selection before updating options per subscription/onetime
    event.preventDefault();
    event.stopImmediatePropagation();
    $(this).closest('.frequency-selector').click();
    //

    var frequency = getFrequency();
    var unit = $('#product-wrap .add-to-cart-form [data-id="rc_shipping_interval_unit_type"]').val();
    var quantity;
    if (unit == "Months") {
      quantity = 12 / frequency;
    } else if (unit == "Days") {
      quantity = 360 / frequency;
    } else {
      console.error('Frequency unit not supported');
      return;
    }
    var btn = $(event.currentTarget);
    var parent = $('.frequency-option');
    $('.frequency-option .purchase-options .item.active').removeClass('active');
    btn.addClass('active');
    parent.find('.js-price').html(btn.data('price'));
    parent.find('.js-note').html(btn.data('note'));
    parent.find('.js-retail span').html(btn.data('retailprice'));

    if (parent.find('.js-retail span').html()!=btn.data('price')) {
      parent.find('.js-retail').show();
    } else {
      parent.find('.js-retail').hide();
    }

    $('#product-wrap .subscription-content, #product-wrap .onetime-content').hide();
    $('.info-cards .grid__item').hide();
    if (btn.hasClass('onetime')) {
      $('.info-cards .grid__item.po-all, .info-cards .grid__item.po-annual').show();
      $('#product-wrap .add-to-cart-form [name="quantity"]').val(quantity);
      $('#product-wrap .onetime-content').show();
      $('#product-wrap .add-to-cart-form [name="purchase_type"][value="onetime"]').prop('checked', 'true');
      $('#product-wrap .subscription-description.onetime-content').html('An annual supply of <br />'+(quantity==1 ? '1 box': quantity+' boxes') + ' per eye' );
    } else {
      $('.info-cards .grid__item.po-all, .info-cards .grid__item.po-subscription').show();
      $('#product-wrap .add-to-cart-form [name="quantity"]').val(1);
      $('#product-wrap .subscription-content').show();
      $('#product-wrap .add-to-cart-form [name="purchase_type"][value="autodeliver"]').prop('checked', 'true');
    }
  });

  var doctsPerState = [];
  var selectizeConfig = {
    valueField: 'id',
    labelField: 'name',
    searchField: 'search',
    sortField: 'name',
    create: false,
    plugins: ['no_results'],
    onFocus: function(event) {
      if ($('#find-doctor').val()!="") {
        $selectFindDoctor[0].selectize.clear();
      }

    },
    render: {
      option: function(item, escape) {
        return '<div style="padding: 5px;"><b>' + escape(item.name) + '</b> <br /><div class="result-city-name"><i>' + escape(item.clinic_name) +'</i></div></div>';
      }
    },
    onType: function(str) {
      var self = this;
      var message = 'No doctors matched your search, click below to add your doctor'; //'No results found that contain "' + self.lastQuery + '"'
      self.$empty_results_container.text(message);
      if (!self.hasOptions && Object.keys(self.options).length>0) {
          self.$empty_results_container.show();
      } else {
          self.$empty_results_container.hide();
      }

      if (!hotjarDoctorSearchTypingEventSent) {
        hotjarDoctorSearchTypingEventSent = true;
        //Hotjar track view
        hj('vpv', '/doctor-searchbar-typing/');
      }
    },
    load: function(query, callback) {

      if (!query.length) return callback();
      var state = $('.state-selector select').val();
      if (doctsPerState[state]) {
        callback(doctsPerState[state]);
        return;
      }

      doctsPerState[state] = [];
      var self = this;

      $.ajax({
        url: 'https://api.hubblecontacts.com/v1/docs/search?state='+state,
        type: 'GET',
        error: function() {
          callback();
        },
        success: function(res) {
          $(res.data.docs).each(function(ix, e){
            this.search = this.name + '|' + this.clinic_name + '|' + this.address_1 + '|' + this.phone + '|' + this.city ;
          })
          doctsPerState[state] = res.data.docs;
          callback(doctsPerState[state]);
          console.log('doctors loaded - '+state);
        }
      });
    }
  }

  var $selectFindDoctor = $('#find-doctor').selectize(selectizeConfig);

  $('.klaviyo-bis-trigger').click(function() {
    var customerEmail = $(this).data('email');
    setTimeout(function() {
      var iframe = $('#klaviyo-bis-iframe').get(0);
      var modal = $(iframe.contentDocument || iframe.contentWindow.document).find('#klaviyo-bis-modal');
      var container = modal.find('#container');
      var email = modal.find('#email');
      modal.attr('style', 'position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%;')
      container.attr('style', 'margin-top: 0');
      email.val(customerEmail);
    },1)
  })

  var brandSelection = $('.brand-selection');
  if (brandSelection.length>0) {
    $('.brand-slider').slick({
      autoplay: false,
      speed: 700,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: '<i class="lnr lnr-chevron-left left-arrow animation"></i>',
      nextArrow: '<i class="lnr lnr-chevron-right right-arrow animation"></i>',
      dots: false,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            dots: true
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            dots: true
          }
        }
      ]
    });
    $('.brand-slider .title').matchHeight();
    thisBrandCTA = $('.btn-select-current-brand, #product-wrap .product-gallery .slide img, #product-wrap .product-frequency .title');
    thisBrandCTAHandler = function() {
      thisBrandCTA.off('click', thisBrandCTAHandler);
      $('#loading-overlay').show();
      $('.shop-tpl-title, .btn-select-current-brand').hide(); //or .slideUp
      $('.brand-selection-element').hide();
      brandSelection.removeClass('brand-selection');
      $('.thumbs.slick-slider').slick('refresh');
      setTimeout(function() {
        //$("html, body").animate({ scrollTop: 0 }, 400); //scroll to top
        $("html, body").animate({ scrollTop: $('.product-options').offset().top - $('#header').outerHeight() - 40 }, 400);
        $('#loading-overlay').hide();
      }, 300);
    }
    thisBrandCTA.click(thisBrandCTAHandler);
    var lastWidth = window.innerWidth;
    $(window).resize(function() {
      setTimeout(function() {
        if (lastWidth!=window.innerWidth) {
          lastWidth = window.innerWidth;
          //workaround to fix cloned items
          $('.brand-slider .title').css('height', '');
          $.fn.matchHeight._apply($('.brand-slider .title'));
        }
      }, 1000);
    })

  }

}

function finishRechargeLoading() {
  ReCharge._baseShowWidget = ReCharge.showWidget;
  ReCharge.showWidget = function() {
    var ret = ReCharge._baseShowWidget();
    window.rechargeLoadComplete = true;
    // $('.frequency-grid .loading-overlay').remove();
    if (!$('#rc_container').hasClass('rc_subscription-only')) {
      $('.frequency-option').addClass('purchase-options-enabled');
    }
    //showOptionsSet();
    $('.frequency-selector .purchase-options .item').first().click();
    return ret;
  }
}

function showOptionsSet(index) {
  if (typeof(index)=='undefined') {
    index = $('.frequency-selector').first().data('index');
  }
  var freqSel = $('.frequency-selector[data-index='+index+']');
  var variantIndex = freqSel.data('variant-index');

  $('.op-grid .op-option').addClass('hide');
  $('.op-grid .op-set-active').val(index);
  $('.op-grid .op-set-'+index).removeClass('hide');

  if ($('#product-wrap .add-to-cart-form [name=properties\\[shipping_interval_frequency\\]]').length>0) {
    //TODO: this code doesn't work for products that allow ONE TIME purchase, so multiple frequencies options aren't working for these products anymore
    var ddl = $('#product-wrap .add-to-cart-form [name=properties\\[shipping_interval_frequency\\]]')[0];
    var freq = freqSel.data('frequency').toLowerCase();
    var ok = false;
    $(ddl.options).each(function(ix, op) {
      var text = op.text.toLowerCase();
      if (text==freq
        || ((freq=='monthly' || freq=='1 month') && (text=='monthly' || text=='1 month')) ) {
        ddl.selectedIndex = ix;
        ok = true;
      }
    });

    if (!ok) {
      console.warn('Frequency metafield doen\'t match any recharge frequency option. Now matching by index');
      //Simplistic.openModal('<div class="error-itemincart"><p>There is a problem with the selected option.</p></div>');
      //defaults to match by index

      $('#product-wrap .add-to-cart-form [name=properties\\[shipping_interval_frequency\\]]')[0].selectedIndex = variantIndex - 1;

    }

  //} else if ($('#product-wrap #rc_autodeliver_options input, #product-wrap #rc_autodeliver_options select').first().val()) {

  }

  $('#product-wrap .add-to-cart-form .swatch[data-option-name="pack size"]').hide();
  $('#product-wrap .add-to-cart-form .swatch[data-option-name="pack size"] .swatch-element label:eq('+(variantIndex-1)+')').click();
}

function getFirst(qs, keys) {
 for (const k of keys) {
   const v = qs.get(k);
   if (v !== null && v !== "") return v;
 }
 return null;
}

function applyFields(baseParams, qs, eyeLabel /* "Left" | "Right" */) {
 // Eye label
 baseParams.set("properties[_eye]", eyeLabel);

 // Map eye-specific keys (support both "l_power" and "properties[l_power]" styles)
 const prefix = eyeLabel === "Left" ? "l_" : "r_";

 const power = getFirst(qs, [prefix + "power", `properties[${prefix}power]`]);
 const baseCurve = getFirst(qs, [prefix + "base_curve", `properties[${prefix}base_curve]`]);
 const diameter = getFirst(qs, [prefix + "diameter", `properties[${prefix}diameter]`]);
 const cylinder = getFirst(qs, [prefix + "cylinder", `properties[${prefix}cylinder]`]);
 const color = getFirst(qs, [prefix + "color", `properties[${prefix}color]`]);
 const additional_power = getFirst(qs, [prefix + "additional_power", `properties[${prefix}additional_power]`]);
 const axis = getFirst(qs, [prefix + "axis", `properties[${prefix}axis]`]);
//  const packSize = getFirst(qs, [prefix + "pack_size", `properties[${prefix}pack_size]`]);




 if (power !== null)     baseParams.set("properties[_power]", power);
 if (baseCurve !== null) baseParams.set("properties[_base_curve]", baseCurve);
 if (diameter !== null)  baseParams.set("properties[_diameter]", diameter);
 if (axis !== null)  baseParams.set("properties[_axis]", axis);
 if (cylinder !== null)  baseParams.set("properties[_cylinder]", cylinder);
 if (additional_power !== null)  baseParams.set("properties[_additional_power]", additional_power);
 if (color !== null)  baseParams.set("properties[_color]", color);
//  if (packSize !== null)  baseParams.set("properties[_pack_size]", packSize);
 baseParams.set("properties[_eye]", eyeLabel);

 // Doctor fields (support either plain or bracketed)
 const doctorId     = getFirst(qs, ["doctor_id", "properties[_doctor_id]"]);
 console.log(doctorId)
 const doctorName   = getFirst(qs, ["_doctor_name", "properties[_doctor_name]"]);
 const doctorState  = getFirst(qs, ["_doctor_state", "properties[_doctor_state]"]);
 const doctorClinic = getFirst(qs, ["_doctor_clinic", "properties[_doctor_clinic]"]);
 const doctorCity   = getFirst(qs, ["_doctor_city", "properties[_doctor_city]"]);
 const utmCampaign   = getFirst(qs, ["utm_campaign", "properties[utm_campaign]"]);
 if (doctorId !== null)     baseParams.set("properties[_doctor_id]", doctorId);
 if (doctorName !== null)   baseParams.set("properties[_doctor_name]", doctorName);
 if (doctorState !== null)  baseParams.set("properties[_doctor_state]", doctorState);
 if (doctorClinic !== null) baseParams.set("properties[_doctor_clinic]", doctorClinic);
 if (doctorCity !== null)   baseParams.set("properties[_doctor_city]", doctorCity);
 if (utmCampaign !== null)   baseParams.set("properties[utm_campaign]", utmCampaign);

 // Discount code (support either plain or bracketed, with or without underscore)
 const discount = getFirst(qs, [
   "discount_code",
   "properties[discount_code]",
   "_discount_code",
   "properties[_discount_code]"
 ]);
 if (discount !== null) baseParams.set("properties[_discount_code]", discount);
 return baseParams;
}


function buildEyeSerializations(singleSerialized, searchString) {
  // Parse the incoming query string from the URL bar
  const qs = new URLSearchParams(searchString || "");

  // Start from your given base single-eye serialized form
  const base = new URLSearchParams(singleSerialized);

  // Create separate copies for Left and Right
  const leftParams  = new URLSearchParams(base.toString());
  const rightParams = new URLSearchParams(base.toString());

  applyFields(leftParams,  qs, "Left");
  applyFields(rightParams, qs, "Right");

  return {
    leftSerialized:  leftParams.toString(),
    rightSerialized: rightParams.toString()
  };
}


function bridgePageCheckout(externalCartParams, eyes) {
    console.log("leo test bridge ")
    var singleserializedForm = $('.add-to-cart-form').serialize()





    const { leftSerialized, rightSerialized } =
      buildEyeSerializations(singleserializedForm, window.location.search);


     
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: leftSerialized,
      dataType: 'json',
      error: addToCartFail,
      success: addToCartSuccess,      
      cache: false
    }).done(function(data) {

      if (eyes != "two"){        
        window.location.href ="/checkout"
        return
      }
      
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: rightSerialized,
        dataType: 'json',
        error: addToCartFail,
        success: addToCartSuccess,      
        cache: false
      }).done(function(data) {
        window.location.href ="/checkout"
      })


    })
    
    console.log("Added to cart")
}


var search_params = new URLSearchParams(window.location.search);
var bridge = search_params.get('bridge');
var bridgePageTest = search_params.get('bridge_page_test')
var eyes = search_params.get('eyes')


window.onload = function() {
  if (bridge != undefined){
  $('.loading-background').show();
  $("#loading-overlay").show();
  $.get('/cart/clear.json')  
    console.log("starting add to cart ")
    window.bridgePageCheckout(window.location.search,eyes)
    console.log("this completed now waiting to go to checkout")   
  }
};

document.addEventListener('DOMContentLoaded', function() {
  if(bridge != undefined) {
  $('.loading-background').show();
  $("#loading-overlay").show();    
  }
});


function setLineItemOptions(items) {
  var visibleProperties = "power:Power;add_power:Add Power;base_curve:Base Curve;D\/N:D\/N;cylinder:Cylinder;axis:Axis;color:Color".split(';');
  var visiblePropertiesObj = {};
  $(visibleProperties).each(function(ix, item) {
    var itemArr = item.split(':');
    visiblePropertiesObj['_'+itemArr[0]] = itemArr[1];
  })

  items.each(function(ix, item) {
    var $item = $(item);
    var propertiesContainer = $item.find('.item-properties');
    var propertiesDoctorContainer = $item.find('.item-properties-doctor');
    if (propertiesDoctorContainer.length==0) {
      propertiesDoctorContainer = propertiesContainer;
    }
    var prescriptionInfo = $('<div class="prescription-info" />');
    propertiesContainer.append(prescriptionInfo);
    var showTitles = propertiesContainer.data('showtitles');
    var showDoctorInfo = propertiesContainer.data('showdoctor');
    var bundle = propertiesContainer.data('bundle');
    var numberOfEyes = items.find('.item-properties[data-bundle="'+bundle+'"]').length;
    var properties = propertiesContainer.data('properties');
    var propertiesObj = {}
    $(properties).each(function(ix, prop) {
      propertiesObj[prop[0]] = prop[1];
    });

    if (showTitles) {
      prescriptionInfo.append($('<div class="properties-heading">Prescription Info</div>'));
    }

    if (numberOfEyes==1) {
      $('<div class="item-property eye-title" />').html('One Eye').appendTo(prescriptionInfo);
    } else {
      if (propertiesObj['_eye']) {
        $('<div class="item-property eye-title" />').html(propertiesObj['_eye'] + ' Eye').appendTo(prescriptionInfo);
      }
    }

    $(properties).each(function(ix, prop) {
      if (visiblePropertiesObj[prop[0]]) {
        $('<div class="item-property" />').html(visiblePropertiesObj[prop[0]]+': '+prop[1]).appendTo(prescriptionInfo);
      }
    });

    if (showDoctorInfo) {
      var doctorInfo = $('<div class="doctor-info" />');
      propertiesDoctorContainer.append(doctorInfo);
      if (showTitles) {
        doctorInfo.append($('<div class="properties-heading">Doctor\'s Info</div>'));
      }

      if (propertiesObj['_prescription_file']) {
        doctorInfo.append( $('<div class="item-property" />').html('<a href="'+propertiesObj['_prescription_file']+'" target="_blank"><span class="view">Click to view</span></a>') );
      } else {
        doctorInfo.append( $('<div class="item-property" />').html('<span class="label">Name:</span> <span class="value">'+propertiesObj['_doctor_name']+'</span>') );
        
      }
    }
  });

}

function customReviewsInit(slider) {
  var tpl = slider.find('.item');
  var critems = [];
  var config = window.globalReviews;
  if (window.productReviews)
    critems = critems.concat(window.productReviews.items);
  if (window.globalReviews) {
    if (critems.length==0)
      critems = window.globalReviews.items;
    else
      critems = critems.concat(window.globalReviews.items.slice(0, 10 -critems.length));
  }

  if (critems.length==0) {
    return;
  }

  slider.closest('.shopify-section').show();

  for (var i=0; i<critems.length; i++) {
    var tplitem = tpl.clone();
    var item = critems[i];
    tplitem.find('.title').html(item.title);
    //var indexLetter = item.author.trim().indexOf(' ');
    var indexLetter = -1; //disable last name cut off
    tplitem.find('.author').html(indexLetter>-1 ? item.author.substr(0, indexLetter+2)+'.' : item.author);
    try {
      tplitem.find('.date').html(item.date);
    } catch (e) {}
    tplitem.find('.stars').html('<i class="fa fa-star"></i>'.repeat(item.stars/1));
    if (item.source_logo) {
      var source_name = item.source.replace('cr_', '');
      var url_source_key = 'url_'+source_name;
      if (config[url_source_key]) {
        tplitem.find('.source').html('<a href="' + config[url_source_key] + '" target="_blank"> <img alt="See more reviews on ' + source_name + '" class="lazyload" data-srcset="' + item.source_logo+ '"/> </a>');
      } else {
        tplitem.find('.source').html('<img class="lazyload" data-srcset="' + item.source_logo + '"/>');
      }
    }
    tplitem.find('.content').html(item.content);
    slider.append(tplitem);
  }
  tpl.remove();
  slider.slick({
    autoplay: false,
    speed: 700,
    pauseOnHover: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow: '<i class="slider-arrow-full left-arrow animation"></i>',
    nextArrow: '<i class="slider-arrow-full right-arrow animation"></i>',
    responsive: [
      {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
      },
      {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
      }
    ]
  });

}
